module.exports = __webpack_public_path__ + "img/15-5.a780e899.jpg";